/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ImpersonationStartRequestDtoToJSON, ImpersonationTokenOutputDtoFromJSON, } from '../models/index';
/**
 *
 */
export class ControllerPerLaGestioneDellimpersonazioneApplicativaApi extends runtime.BaseAPI {
    /**
     * Avvia una sessione di impersonazione verso l\'utente indicato e restituisce un JWT dedicato che porta i ruoli reali del target. Il chiamante deve essere SUPER_ADMIN e non deve essere già in una sessione di impersonazione.
     * Avvia impersonazione
     */
    startImpersonationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['targetUsername'] == null) {
                throw new runtime.RequiredError('targetUsername', 'Required parameter "targetUsername" was null or undefined when calling startImpersonation().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/impersonation/start/{targetUsername}`.replace(`{${"targetUsername"}}`, encodeURIComponent(String(requestParameters['targetUsername']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ImpersonationStartRequestDtoToJSON(requestParameters['impersonationStartRequestDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ImpersonationTokenOutputDtoFromJSON(jsonValue));
        });
    }
    /**
     * Avvia una sessione di impersonazione verso l\'utente indicato e restituisce un JWT dedicato che porta i ruoli reali del target. Il chiamante deve essere SUPER_ADMIN e non deve essere già in una sessione di impersonazione.
     * Avvia impersonazione
     */
    startImpersonation(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.startImpersonationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Registra la fine della sessione di impersonazione corrente. Non invalida alcun token lato server: il ripristino del token reale è a carico del frontend.
     * Termina impersonazione
     */
    stopImpersonationRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/impersonation/stop`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Registra la fine della sessione di impersonazione corrente. Non invalida alcun token lato server: il ripristino del token reale è a carico del frontend.
     * Termina impersonazione
     */
    stopImpersonation(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.stopImpersonationRaw(initOverrides);
        });
    }
}
